
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/osrodek-narciarski",
      function () {
        return require("private-next-pages/[region]/[resort]/osrodek-narciarski.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/osrodek-narciarski"])
      });
    }
  